<script lang="ts">
    import {Flex, Spacer} from 'shared/layouts';
    import {RecordFieldsDetailGrid, type RecordFieldsDetailGridOptions} from 'src/features/erp-sutor/features/record-fields-detail-grid';
    import {ErpFondPermissionContainer} from 'src/features/erp/components';
    import type {SutorEmployeeDetail} from './types';
    import {FOND_EMPLOYMENT_STATUS, FOND_JOB_FILE} from 'src/features/erp-sutor/sutor-fonds';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';
    import EmployeeTextNoteEditor from './EmployeeTextNoteEditor.svelte';

    export let employeeDetail: SutorEmployeeDetail;

    // Fond 83 (pracovní karta)
    const personCardRecordDetailOptions: RecordFieldsDetailGridOptions = {
        customDisplayFields: [
            FOND_JOB_FILE.birthNumberFieldId,
            FOND_JOB_FILE.identityCardNumberFieldId,
            FOND_JOB_FILE.genderFieldId,
            FOND_JOB_FILE.birthDateFieldId,
            FOND_JOB_FILE.birthPlaceFieldId,
            FOND_JOB_FILE.nationalityFieldId,
            FOND_JOB_FILE.idCardNumberFieldId,
            FOND_JOB_FILE.idCardValidityFieldId,
            FOND_JOB_FILE.educationLevelFieldId,
            FOND_JOB_FILE.educationInstitutionFieldId,
            FOND_JOB_FILE.healthInsuranceCodeFieldId,
            FOND_JOB_FILE.maternityLeaveStartFieldId,
            FOND_JOB_FILE.maternityLeaveEndFieldId,
            FOND_JOB_FILE.parentalLeaveStartFieldId,
            FOND_JOB_FILE.parentalLeaveEndFieldId,
            FOND_JOB_FILE.invalidityFieldId,
            FOND_JOB_FILE.claimedChildrenFieldId,
            FOND_JOB_FILE.unclaimedChildrenFieldId,
            FOND_JOB_FILE.distrainmentTypeFieldId,
            {
                value: employeeDetail.personCardOrder,
                text: 'Pořadí pracovní karty'
            }
        ]
    };

    // Fond 88 (pracovní poměr)
    const employmentRecordDetailOptions: RecordFieldsDetailGridOptions = {
        customDisplayFields: [
            FOND_EMPLOYMENT_STATUS.personalNumberFieldId,
            FOND_EMPLOYMENT_STATUS.employmentStartDateFieldId,
            FOND_EMPLOYMENT_STATUS.trialPeriodEndDateFieldId,
            FOND_EMPLOYMENT_STATUS.employmentEndDateFieldId,
            FOND_EMPLOYMENT_STATUS.workPositionFieldId,
            FOND_EMPLOYMENT_STATUS.divisionFieldId,
            FOND_EMPLOYMENT_STATUS.bossFieldId,
            FOND_EMPLOYMENT_STATUS.contractTypeFieldId,
            FOND_EMPLOYMENT_STATUS.contractDateFieldId,
            FOND_EMPLOYMENT_STATUS.contractCategoryFieldId,
            FOND_EMPLOYMENT_STATUS.employerFieldId,
            FOND_EMPLOYMENT_STATUS.employerIcoFieldId,
            FOND_EMPLOYMENT_STATUS.typeOfTerminationFieldId,
            FOND_EMPLOYMENT_STATUS.sideOfTerminationFieldId,
            FOND_EMPLOYMENT_STATUS.reasonForTerminationFieldId,
            {
                value: employeeDetail.employmentOrder,
                text: 'Pořadí pracovního poměru'
            },
            {
                text: 'Poznámka',
                component: EmployeeTextNoteEditor,
                props: {
                    employmentRecord: employeeDetail.employmentRecord
                }
            }
        ]
    };
</script>

<ErpFondPermissionContainer editableFondId={[FOND_JOB_FILE.fond, FOND_EMPLOYMENT_STATUS.fond]} checkType="has-some">
    <Flex direction="column" gap="6rem">
        <ErpFondPermissionContainer editableFondId={FOND_JOB_FILE.fond}>
            <RecordFieldsDetailGrid record={employeeDetail.personCardRecord} options={personCardRecordDetailOptions}>
                <svelte:fragment slot="title-header">
                    <Flex direction="row" gap="m" alignItems="center">
                        <KpHeading type="h2">Výpis pracovní karty</KpHeading>

                        <KpChipTag chipSize="xs" chipStyle={employeeDetail.personCardActive ? 'success' : 'danger'}>
                            {employeeDetail.personCardActive ? 'Aktivní' : 'Neaktivní'}
                        </KpChipTag>
                    </Flex>
                </svelte:fragment>

                <svelte:fragment slot="null-record-text">
                    Pracovník nemá žádnou pracovní kartu
                </svelte:fragment>
            </RecordFieldsDetailGrid>
        </ErpFondPermissionContainer>

        <ErpFondPermissionContainer editableFondId={FOND_EMPLOYMENT_STATUS.fond}>
            <RecordFieldsDetailGrid record={employeeDetail.employmentRecord} options={employmentRecordDetailOptions}>
                <svelte:fragment slot="title-header">
                    <Flex direction="row" gap="m" alignItems="center">
                        <KpHeading type="h2">Výpis pracovního poměru</KpHeading>

                        <KpChipTag chipSize="xs" chipStyle={employeeDetail.employmentActive ? 'success' : 'danger'}>
                            {employeeDetail.employmentActive ? 'Aktivní' : 'Neaktivní'}
                        </KpChipTag>
                    </Flex>
                </svelte:fragment>

                <svelte:fragment slot="null-record-text">
                    Pracovník nemá žádný pracovní poměr
                </svelte:fragment>
            </RecordFieldsDetailGrid>
        </ErpFondPermissionContainer>
    </Flex>

    <Spacer direction="vertical" size="xxl"/>
    <Spacer direction="vertical" size="xxl"/>
</ErpFondPermissionContainer>
